import React, { useState, memo } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import Table from '../../Table';

import ReportService from '../../../services/ReportService';

const filterOptions = [
  {
    label: '2023',
    value: '2023',
  },
  {
    label: '2024',
    value: '2024',
  },
  {
    label: '2025',
    value: '2025',
  },
];

const createLoanLink = (row, tab) =>
  `/loans/${row?.loan?.id || row?.loan?.loan_id}?tab=${tab}`;

function TaxAuditTable() {
  const [taxYear, setTaxYear] = useState([new Date().getFullYear().toString()]);

  const { t } = useTranslation();

  const { data: taxAudit } = useQuery({
    queryKey: ['taxAudit', taxYear],
    queryFn: () => ReportService.getTaxAuditReport(taxYear[0]),
  });

  const cols = [
    {
      title: t('common.tables.columns.Loan'),
      keys: ['loan.pixel_loan_number'],
      link: (row) => createLoanLink(row, 'Loan'),
    },
    {
      title: t('common.tables.columns.Property'),
      keys: ['loan._property.address_line_1'],
      link: (row) => createLoanLink(row, 'Property'),
    },
    {
      title: t('common.tables.columns.Borrower'),
      keys: ['doesntmatter'],
      format: (_, row) =>
        row?.loan?._borrower_primary?.TIN_type === 'EIN'
          ? row?.loan?._borrower_primary?.entity_name
          : `${row?.loan?._borrower_primary?.first_name} ${row?.loan?._borrower_primary?.last_name}`,
      link: (row) => createLoanLink(row, 'Borrowers'),
    },
    {
      title: t('common.tables.columns.Alert'),
      keys: ['alert'],
    },
  ];

  return (
    <Table
      cols={cols}
      minHeight={565}
      rows={taxAudit}
      title=""
      filterOptions={filterOptions}
      filterLabel="Tax Year"
      filterValue={taxYear}
      onFilterChange={(value) => setTaxYear(value)}
    />
  );
}

export default memo(TaxAuditTable);
